import { RecentLeaderProvider } from "@/context/RecentLeaderBoardContext";
import RecentTable from "@/components/RecentTable";
import OddStatistic from "@/components/OddStatistic";
import CollapsiblePanel from "@/components/CollapsiblePanel";
import GoalStatistic from "@/components/GoalStatistic";

const RecentLeaderBoardContainer = ({ leagueId, home, away, formStats, goalStats, oddStats , match}) => {
  return (
    <RecentLeaderProvider
      initialHome={home}
      initialAway={away}
      initialFormStats={formStats}
      leagueId={leagueId}
    >
      <CollapsiblePanel
        title="Thành tích gần đây"
      >
        <RecentTable />
        <OddStatistic oddStats={oddStats} match={match} />
        <GoalStatistic goalStats={goalStats} />
      </CollapsiblePanel>
    </RecentLeaderProvider>
  );
};

export default RecentLeaderBoardContainer;
